import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";

import { HistoryModel } from "@/views/historyModel";
import { useJxcModel } from "../jxcModel";

//进销存报表
export default () => {
    const {
        historyVisible, setHistoryVisible,
        historyRow
    } = useJxcModel();
    return (
        <>
            <PageHeader />
            <DataBox />
            <HistoryModel
                visible={historyVisible}
                materialCode={historyRow?.materialCode as string}
                materialName={historyRow?.materialName as string}
                onCancel={() => setHistoryVisible(false)}
            />
        </>
    )
}